import React from "react";

import STRATEGIC_PARTNER from "../../constants/strategicPartners";

const email = STRATEGIC_PARTNER.CONTACT_SUPPORT.EMAIL;


const SupportEmailLink = ({textOverride, ...props}) => (
    <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer" {...props}>{textOverride || email}</a>
);

export default SupportEmailLink;